<template style="background-color: white;">
    <div style="background-color: white; line-height: 1.7em;">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar><br><br>
        <div class="row" style="height: 720px; border-right: 15px solid #623e7e; border-left: 15px solid #623e7e;">
            <div class="col-6" style="border: 15px solid #623e7e; border-right: 15px solid #623e7e;background-color: #D1C5EE ;">
                <v-row dense justify="center">
                    <v-col cols="10" sm="10" md="10" class="pr-8">
                        <table style="width: 100%;border-collapse: collapse;">
                            <tr v-for="g,index in remarks_list" :key="index">
                                <th style="width: 30%;">{{ g.symbol }}</th>
                                <td style="width: 30%;" class="pl-2"> <strong>{{ g.remark }}</strong> </td>
                            </tr>
                        </table>
                    </v-col>
                </v-row>
                <v-row dense justify="center">
                    <v-col cols="12" sm="6" md="6" class="pr-8">
                        <center><strong>GRADE KEY</strong></center>
                        <table style="width: 100%;border-collapse: collapse;">
                            <tr v-for="g in grade_details" :key="g.id" v-if="g.gradename != '-'">
                                <th style="width: 30%;">{{ g.gradename }}</th>
                                <th style="width: 30%;">{{ g.range }}</th>
                                <td class="pl-2"><strong>{{ g.graderemark }}</strong></td>
                            </tr>
                        </table>
                    </v-col>
                </v-row>
            </div>
            <div class="col-6" style="border: 15px solid #623e7e; border-left: 15px solid #623e7e; background-color: #d1c5ee;">
                <span style="text-transform: uppercase; font-size: xx-large; font-weight: bolder; color: #450676;"> <center>{{ org_basic_data.trust_name }}</center> </span>
                <span style="color: #450676;"><center>{{ org_basic_data.address }}</center></span>
                <center><img src="https://eduplusschool.s3.ap-south-1.amazonaws.com/logo/WWS_Logo-01.png" width="140px" height="140px" alt="logo" /></center>
                <center>
                    <div style="border: 5px solid #623e7e; width: 370px; height: 240px;"><img src="@/assets/wakad_image.png" alt="" width="350px" height="220px" class="mt-1" style="border: 2px solid #623e7e;" /></div>
                </center>
                <br />
                <span style="text-transform: uppercase; font-size: xx-large; font-weight: bolder;"> <center>Report Card</center> </span> <br />
                <div class="row pl-2" style="text-transform: uppercase; font-size: large; font-weight: bolder;margin-top: -25px;">
                    <div class="col-12">  <div class="row ">Name :  <div style="width: 80%; margin-left: 5px;" class="stud_details2">{{ name }} <span class="pl-1"></span> {{ sur_name }}</div></div>  </div>
                   <div class="col-6"> <div class="row ">std : <div style="width: 70%; margin-left: 5px;" class="stud_details2">{{ standard }}</div></div></div>
                    <div class="col-6"><div class="row ">Div : <div style="width: 68%; margin-left: 5px;" class="stud_details2">{{ div }}</div></div></div>
                </div>
                <span style="text-transform: uppercase; font-size: x-large; font-weight: bolder;"> <center>{{ay}}</center> </span>
            </div></div>
        <div class="row pagebreak" style="margin-top: -15px;">
            <div class="col-6">
                <b style="font-size: 12px;"> Student Name: {{ name }} {{ sur_name }} </b>
                <b style="font-size: 12px; margin-left: 300px;"> 1st Term </b>
            </div>
            <div class="col-6">
                <b style="font-size: 12px;"> 2nd Term </b>
                <b style="font-size: 12px; margin-left: 200px;"> Roll No.: {{ roll_no }} </b>
                <b style="font-size: 12px; margin-left: 50px;"> Class: {{ standard }} </b>
                <b style="font-size: 12px;"> Div: {{ div }} </b>
            </div>
            <div class="col-6 table-container" style="margin-top: -30px;">
                <table v-for="data,index1 in leraner_marksheet" :key="index1" style="height: 300px;">
                    <thead>
                        <tr>
                            <th colspan="2" v-if="index1==0" style="height: 45px;">
                                <div>Marks out of 100</div>
                                <div style="margin-top: -15px;">
                                    Pass Marks for each subject is 33%
                                </div>
                            </th>
                            <th colspan="3" style="width: 300px; height: 45px;">
                                {{ass_type_term_1[index1]}}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="s, index in data" :key="index">
                            <td colspan="2" v-if="index1==0" style="text-transform: uppercase; width: 350px;" class="pl-2">
                                <strong>
                                    {{ index }}
                                    <span v-if="s[0].sub_marks < 100 || s[0].sub_marks > 100">{{ s[0].crs_marks }}</span>
                                </strong>
                            </td>
                            <td style="height: 30px;">
                                <center>
                                    <strong>
                                        {{ s[0].marks }}
                                    </strong>
                                </center>
                            </td>
                            <td v-if="s[0].count != 0 && display_flag_avg == true" :rowspan="s[0].count" class="pb-5">
                                <strong>
                                    <center>{{ s[0].avg }}</center>
                                </strong>
                            </td>
                            <td v-else-if="s[0].credit == 0 && display_flag_avg == true"></td>
                            <td style="height: 30px; width: 50px;">
                                <center>
                                    <strong>
                                        {{ s[0].comment }}
                                    </strong>
                                </center>
                            </td>
                        </tr>
                        <tr>
                            <td style="height: 30px;" class="pl-2" colspan="2" v-if="index1==0">
                                <strong>ATTENDANCE</strong>
                            </td>
                            <td style="height: 30px;">
                                <span v-for="at,ind in attendance_list_sem_1[index1]" :key="ind">
                                    <center>
                                        <strong> {{ at.present }}/{{ at.total_working_stud }} </strong>
                                    </center>
                                </span>
                            </td>
                            <td style="height: 30px;" v-if="display_flag_avg == true"></td>
                            <td style="height: 30px;"></td>
                        </tr>
                        <tr>
                            <td style="height: 30px;" class="pl-2" colspan="2" v-if="index1==0">
                                <strong>Total </strong>
                            </td>
                            <td style="height: 30px;">
                                <span v-if="ass_type_hide_show_percentage[index1]">
                                    <center>
                                        <strong>
                                            {{ total_marks_ass_type[index1] }}
                                        </strong>
                                    </center>
                                </span>
                                <span v-else>
                                    <center>
                                        <strong> - </strong>
                                    </center>
                                </span>
                            </td>
                            <td style="height: 30px;" v-if="display_flag_avg == true"></td>
                            <td style="height: 30px;"></td>
                        </tr>
                        <tr>
                            <td style="height: 30px;" class="pl-2" colspan="2" v-if="index1==0">
                                <strong>Percentage </strong>
                            </td>
                            <td style="height: 30px;">
                                <span v-if="ass_type_hide_show_percentage[index1]">
                                    <center>
                                        <strong>
                                            {{ percentage_list_ass_type[index1] }}
                                        </strong>
                                    </center>
                                </span>
                                <span v-else>
                                    <center>
                                        <strong> - </strong>
                                    </center>
                                </span>
                            </td>
                            <td style="height: 30px;" v-if="display_flag_avg == true"></td>
                            <td style="height: 30px;"></td>
                        </tr>
                        <tr>
                            <td style="height: 30px;" class="pl-2" colspan="2" v-if="index1==0">
                                <strong>TEACHER ISSUING THE REPORT CARD </strong>
                            </td>
                            <td style="height: 30px;">
                                <center>
                                    <strong>
                                        {{ inst_name }}
                                    </strong>
                                </center>
                            </td>
                            <td style="height: 30px;" v-if="display_flag_avg == true"></td>
                            <td style="height: 30px;"></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="col-6 table-container" style="margin-top: -30px;">
                <!--sem 2 data-->
                <table v-for="data,index1 in leraner_marksheet" :key="index1" style="height: 300px;">
                    <thead>
                        <tr>
                            <th colspan="3" style="width: 300px; height: 45px;">
                                {{ass_type_term_2[index1]}}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="s, index in data" :key="index">
                            <td style="height: 30px;">
                                <center>
                                    <strong>
                                        {{ s[0].marks }}
                                    </strong>
                                </center>
                            </td>
                            <td v-if="s[0].count != 0 && display_flag_avg == true" :rowspan="s[0].count" class="pb-5">
                                <strong>
                                    <center>{{ s[0].avg }}</center>
                                </strong>
                            </td>
                            <td v-else-if="s[0].credit == 0 && display_flag_avg == true"></td>
                            <td style="height: 30px; width: 50px;">
                                <center>
                                    <strong>
                                        {{ s[0].comment }}
                                    </strong>
                                </center>
                            </td>
                        </tr>
                        <tr>
                            <td style="height: 30px;">
                                <span v-for="at,ind in attendance_list_sem_2[index1]" :key="ind">
                                    <center>
                                        <strong> {{ at.present }}/{{ at.total_working_stud }} </strong>
                                    </center>
                                </span>
                            </td>
                            <td style="height: 30px;" v-if="display_flag_avg == true"></td>
                            <td style="height: 30px;"></td>
                        </tr>
                        <tr>
                            <td style="height: 30px;">
                                <span v-if="ass_type_hide_show_percentage[index1]">
                                    <center>
                                        <strong>
                                            {{ total_marks_ass_type[index1] }}
                                        </strong>
                                    </center>
                                </span>
                                <span v-else>
                                    <center>
                                        <strong> - </strong>
                                    </center>
                                </span>
                            </td>
                            <td style="height: 30px;" v-if="display_flag_avg == true"></td>
                            <td style="height: 30px;"></td>
                        </tr>
                        <tr>
                            <td style="height: 30px;">
                                <span v-if="ass_type_hide_show_percentage[index1]">
                                    <center>
                                        <strong>
                                            {{ percentage_list_ass_type[index1] }}
                                        </strong>
                                    </center>
                                </span>
                                <span v-else>
                                    <center>
                                        <strong> - </strong>
                                    </center>
                                </span>
                            </td>
                            <td style="height: 30px;" v-if="display_flag_avg == true"></td>
                            <td style="height: 30px;"></td>
                        </tr>
                        <tr>
                            <td style="height: 30px;">
                                <center>
                                    <strong>
                                        {{ inst_name }}
                                    </strong>
                                </center>
                            </td>
                            <td style="height: 30px;" v-if="display_flag_avg == true"></td>
                            <td style="height: 30px;"></td>
                        </tr>
                    </tbody>
                </table>
                <!--overall data table-->
                <table style="height: 300px; width: 200px;">
                    <thead>
                        <tr>
                            <th colspan="3" style="height: 45px;">
                                <div>Overall Average Of Unit 1-4</div>
                                <div style="margin-top: -15px;">{{ ay }}</div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="ov, index in overall_data" :key="index">
                            <td style="height: 30px;">
                                <center>
                                    <strong>
                                        {{ ov.marks }}
                                    </strong>
                                </center>
                            </td>
                            <td v-if="ov.count != 0 && display_flag_avg == true" :rowspan="ov.count" class="pb-5">
                                <strong>
                                    <center>{{ ov.avg }}</center>
                                </strong>
                            </td>
                            <td v-else-if="ov.credit == 0 && display_flag_avg == true"></td>
                            <td style="height: 30px; width: 50px;">
                                <center>
                                    <strong>
                                        {{ ov.comment }}
                                    </strong>
                                </center>
                            </td>
                        </tr>
                        <tr>
                            <td style="height: 30px;">
                                <center>
                                    <strong>
                                        <!-- {{ attendance_list_overall[0].present }}/{{ attendance_list_overall[0].total_working_stud }} -->
                                        -
                                    </strong>
                                </center>
                            </td>
                            <td style="height: 30px;" v-if="display_flag_avg == true"></td>
                            <td style="height: 30px;"></td>
                        </tr>
                        <tr>
                            <td style="height: 30px;">
                                <span v-if="show_hide_avg_overall">
                                    <center>
                                        <strong>
                                            <!-- {{ obtained_marks }} / {{ totalmarks }} -->
                                            -
                                        </strong>
                                    </center>
                                </span>
                                <span v-else>
                                    <center>
                                        <strong> - </strong>
                                    </center>
                                </span>
                            </td>
                            <td style="height: 30px;" v-if="display_flag_avg == true"></td>
                            <td style="height: 30px;"></td>
                        </tr>
                        <tr>
                            <td style="height: 30px;">
                                <span v-if="show_hide_avg_overall">
                                    <center>
                                        <strong>
                                            {{ percentage }}
                                        </strong>
                                    </center>
                                </span>
                                <span v-else>
                                    <center>
                                        <strong> - </strong>
                                    </center>
                                </span>
                            </td>
                            <td style="height: 30px;" v-if="display_flag_avg == true"></td>
                            <td style="height: 30px;"></td>
                        </tr>
                        <tr>
                            <td style="height: 30px;">
                                <center>
                                    <strong>
                                        {{ inst_name }}
                                    </strong>
                                </center>
                            </td>
                            <td style="height: 30px;" v-if="display_flag_avg == true"></td>
                            <td style="height: 30px;"></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="row pl-5" style="margin-top: -10px;margin-left: 0.1px;">
                <div style="font-size: 13px; font-family: 'Times New Roman', Times, serif; line-height: 130%;">
                    <strong>General Remark: </strong>
                    <span>{{ marksheet_remark }} </span>
                </div>
            </div>
            <div class="row ml-3" style="margin-top: 5px; font-family: 'Times New Roman', Times, serif;">
                <div class="col-8">
                    <strong>Promoted To</strong>
                </div>
                <div class="col-4">
                    <strong>Principal's Sign</strong>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        props: {
            org: Number,
        },
        data() {
            return {
                default_value: [],
                dialog_marks: false,
                overlay: false,
                selected: [],
                snackbar: false,
                search: "",
                snackbar_msg: "",
                color: "",
                attendance_list_sem_1: [],
                attendance_list_sem_2: [],
                ass_type_term_2: [],
                ass_type_term_1: [],
                ay_std_div_list: null,
                sel_ay_data: null,
                asd: null,
                fetch_loader: false,
                show: false,
                course_list: [],
                remarks_list:[],
                stud_list: [],
                awspath: "",
                registration_no: null,
                standard: null,
                div: null,
                ay: null,
                name: null,
                sur_name: null,
                leraner_marksheet: [],
                leraner_marksheet_sem_2: [],
                colspan: null,
                overall_grade: null,
                remark: [],
                org_basic_data: [],
                assessment_type: null,
                grade_details: [],
                inst_name: null,
                percentage: null,
                obtained_marks: null,
                totalmarks: null,
                attendance: null,
                display_flag_avg: null,
                display_flag_ca: null,
                per_cal: null,
                hide_percentage_total: null,
                ass_type_hide_show_percentage: [],
                overall_data: [],
                total_marks_ass_type: [],
                percentage_list_ass_type: [],
                show_hide_avg_overall: null,
                marksheet_remark: [],
                attendance_list_overall: [],
            };
        },
        mounted() {
            this.awspath = localStorage.getItem("awspath");
            this.sel_ay_data = localStorage.getItem("setay");
            this.registration_no = localStorage.getItem("setreg_no");
            this.onload();
        },
        methods: {
            print() {
                this.$store.state.drawer = false;
                let that = this;
                window.onafterprint = function () {
                    that.$store.state.drawer = true;
                };
                setTimeout(function () {
                    window.print();
                }, 100);
            },

            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onload() {
                const data = {
                    lid: this.registration_no,
                    ay: this.sel_ay_data,
                    asd: this.asd,
                    org: this.org,
                };
                axios
                    .post("/WWSExamination/generatelearnermarksheetannual", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.standard = res.data.standard;
                            this.div = res.data.div;
                            this.ay = res.data.ay;
                            this.name = res.data.name;
                            this.roll_no = res.data.roll_no;
                            this.photo = res.data.photo;
                            this.sur_name = res.data.sur_name;
                            this.leraner_marksheet = res.data.leraner_marksheet;
                            this.leraner_marksheet_sem_2 = res.data.leraner_marksheet_sem_2;
                            this.org_basic_data = res.data.org_basic_data;
                            this.assessment_type = res.data.assessment_type;
                            this.grade_details = res.data.grade_details;
                            this.inst_name = res.data.inst_name;
                            this.percentage = res.data.percentage;
                            this.obtained_marks = res.data.obtained_marks;
                            this.totalmarks = res.data.totalmarks;
                            this.attendance = res.data.attendance;
                            this.display_flag_avg = res.data.display_flag_avg;
                            this.display_flag_ca = res.data.display_flag_ca;
                            this.remarks_list = res.data.remarks_list;
                            this.per_cal = res.data.per_cal;
                            this.hide_percentage_total = res.data.hide_percentage_total;
                            this.attendance_list_sem_1 = res.data.attendance_list_sem_1;
                            this.attendance_list_sem_2 = res.data.attendance_list_sem_2;
                            this.ass_type_term_1 = res.data.ass_type_term_1;
                            this.ass_type_term_2 = res.data.ass_type_term_2;
                            this.ass_type_hide_show_percentage = res.data.ass_type_hide_show_percentage;
                            this.overall_data = res.data.overall_data;
                            this.total_marks_ass_type = res.data.total_marks_ass_type;
                            this.percentage_list_ass_type = res.data.percentage_list_ass_type;
                            this.show_hide_avg_overall = res.data.show_hide_avg_overall;
                            this.marksheet_remark = res.data.marksheet_remark;
                            this.attendance_list_overall = res.data.attendance_list_overall;
                        }
                        if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.smsg); // show snackbar
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
        },
    };
</script>

<style scoped>
    /* .diagonalCross2 {
        background: linear-gradient(to top left, #fff calc(50% - 1px), black, #fff calc(50% + 1px));
    }
    .avg {
        font-weight: 100px;
    }
    .stud_details1 {
        border-bottom: 1px solid rgb(120, 112, 206);
        font-family: "Times New Roman", Times, serif;
        height: 25px;
    } */
    tr,
    td,
    th,
    table {
        font-size: 10px;
        border: 0.2px solid black;
        border-collapse: separate;
        font-family: "Times New Roman", Times, serif;
    }
    .table-container {
        display: flex;
    }
    .table-container table {
        border-collapse: collapse;
        border-spacing: 0;
        border: none;
    }
    div {
        font-family: "Times New Roman", Times, serif;
    }

    @media print {
        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
        }
        th,
        td {
            white-space: nowrap;
        }
        @page {
            size: A4 landscape !important;
            size: 25.5in 19in;
            font-family: "Times New Roman", Times, serif;
            margin-top: -1.2645833mm;
        }
        .pagebreak {
            page-break-before: always;
            line-height: -50px !important;
        }
    }
    .stud_details2 {
        border-bottom: 1px solid black;
        height: 25px;
    }

    /* @media print {
        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
        }

        .card {
            border: none !important;
        }
        @page {
            size: A4 portrait;
            margin-top: none;
            padding-top: none;
            size: 25in 16in;
            font-family: "Times New Roman", Times, serif;
        }
    } */
</style>
